import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { BimplusUserIdResolverService, ROUTE } from 'shared';
import { map } from 'rxjs';
import { TermsAcceptanceService } from '../data-access/terms/terms-acceptance.service';

const SKIP_TERMS_ACCEPTANCE = false;

export const termsAcceptanceGuard: CanActivateFn = (_, state) => {
  if (SKIP_TERMS_ACCEPTANCE) {
    return true;
  }

  const termsAcceptanceService = inject(TermsAcceptanceService);
  const userIdResolverService = inject(BimplusUserIdResolverService);
  const router = inject(Router);

  const redirectToTerms = () =>
    router.createUrlTree(['/', ROUTE.terms], {
      queryParams: { redirectTo: state.url },
    });

  const resolveResultForUserId = (resolvedUserId: string) => {
    if (!resolvedUserId) {
      return redirectToTerms();
    }

    return termsAcceptanceService.hasAcceptedCurrentVersion(resolvedUserId)
      ? true
      : redirectToTerms();
  };

  return userIdResolverService
    .resolveCurrentUserId$()
    .pipe(map(resolvedUserId => resolveResultForUserId(resolvedUserId)));
};
